import {IUser} from '@wix/yoshi-flow-editor'

const initialData = {
  id: null,
  role: null,
  loggedIn: false,
}

export const currentUser = (state: Partial<IUser> = initialData) => state
